import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import moment from 'moment';
import DatePicker from 'react-datepicker';
import "react-month-picker-calendar/dist/react-month-picker-input.css";
import StatefulMultiSelect from "@khanacademy/react-multi-select";

export default class OutsourcedJobsReport extends Component {
    constructor(props) {
        super(props);
    console.log(this.props);
    console.log(this.state);
        this.state = {
            isLoading:false,
            reportUrl:'/api/v1/portal/portal-admin/outsourced-jobs-report/',
            totaloutsourcedJobs:[],
            startDate:moment().toDate(),
            endDate:moment().toDate(),
            filename:'Inter Company Jobs Report',
            isDownloading:false,
            selectedCustomers:[],
            customers:[],
            url: "/api/v1/portal/customers/all/for-dropdown-menu",
        };
        this.handleStartDateChange = this.handleStartDateChange.bind(this);
        this.handleEndDateChange = this.handleEndDateChange.bind(this);
        this.handleCustomerSelection = this.handleCustomerSelection.bind(this);
    }
    componentDidMount() {
        let options = [];   
        return fetch(this.state.url, {
          method: "GET",
          mode: "cors",
          cache: "no-cache",
          credentials: "same-origin",
          headers: {
            "Authorization": 'Bearer ' + window.api_token
            , "Accept": 'application/json'
          },
        }).then((responseText) => {
          let response = responseText.json();
          response.then((response) => {
              response.map((customer)=>{
                options.push({
                    label : customer.company.short_name+'-'+customer.name,
                    value : customer.id
                });
            });
            this.setState({
              customers: options,
              isLoading: false
            });
          });
        });
    }
    handleStartDateChange(date) {
        this.setState({startDate: date})
    }
    handleEndDateChange(date) {
        this.setState({endDate: date})
    }
    handleCustomerSelection(selectedCustomers) {
        this.setState({selectedCustomers});
    }
    handleTotalJobsRaisedByUserReportGenerate(e) {
        this.setState({isLoading: true});
        let url = this.state.reportUrl+moment(this.state.startDate).format("YYYY-MM-DD")+'/'+moment(this.state.endDate).format("YYYY-MM-DD");

        return fetch(url, {
          method: "POST",
          mode: "cors",
          cache: "no-cache",
          credentials: "same-origin",
          headers: {
            "Authorization": 'Bearer ' + window.api_token
            , "Accept": 'application/json'
          },
          body: JSON.stringify({
            customer_ids: this.state.selectedCustomers,
          }),
        }).then((responseText) => {
            let response = responseText.json();
            response.then((response) => {
              //console.log(response.users);  
              this.setState({
                totaloutsourcedJobs: response,
                isLoading: false
              })
            });
        }).catch(err=>{
            alert('sorry something went wrong.'+err);
        });
    }

    downloadableCsvData(filename,text){
        this.setState({isDownloading: true});
        let filenamed = filename+" FROM "+moment(this.state.startDate).format("YYYY-MM-DD")+" TO "+moment(this.state.endDate).format("YYYY-MM-DD")+".csv";
        let textdata = "JOB REF,REG/VIN,CUSTOMER,SUBCONTRACTED TO,STATUS,DRIVER COMPLETED DATE,INVOICE NUMBER,JOB PRICE\n"+text;
        let element = document.createElement('a');
        element.setAttribute('href','data:text/plain;charset=utf-8,' + encodeURIComponent(textdata));
        element.setAttribute('download', filenamed);
        element.style.display = 'none';
        document.body.appendChild(element);
        element.click();
        document.body.removeChild(element);
        this.setState({isDownloading: false});
    }
    render() {
        let totaloutsourcedJobs = [];
        const {selectedCustomers} = this.state;
        let downloadCsvData = [];
        let finalTotal = 0;
            
            if(this.state.totaloutsourcedJobs && this.state.totaloutsourcedJobs.acv && this.state.totaloutsourcedJobs.acv.length > 0){
                let totalACVJobPrice = 0.00;
                this.state.totaloutsourcedJobs.acv.map((job, index) => {
                    let joburl = "/jobs/view/"+job.id;
                    totaloutsourcedJobs.push(
                        <tr key={index+'-'+job.id}>
                            <td className="job-ref-font16"><a href={joburl}>{job.id}</a></td>
                            <td>{ job.vehicle.registration_number}</td> 
                            <td>{ job.customer.name}</td>
                            <td>{ job.subcontracted_to_company.short_name}</td>
                            <td>{ job.status}</td>
                            <td>{((job.driver_completed_at) ? moment(job.driver_completed_at).format("DD/MM/YY") : "")}</td>
                            <td>{ job.invoice_number}</td>       
                            <td>&pound;{ job.job_price}</td>
                        </tr>
                    );
                    totalACVJobPrice = parseFloat(totalACVJobPrice) + parseFloat(job.job_price);
                    downloadCsvData = downloadCsvData +
                                            job.id+','+
                                            job.vehicle.registration_number+','+
                                            job.customer.name+','+
                                            job.subcontracted_to_company.short_name+','+
                                            job.status+','+
                                            ((job.driver_completed_at) ? moment(job.driver_completed_at).format("DD/MM/YY") : "")+','+
                                            job.invoice_number+','+
                                            job.job_price+"\n";
                });
                finalTotal = parseFloat(finalTotal) + parseFloat(totalACVJobPrice);
                totaloutsourcedJobs.push(
                    <tr key="acvtotal" className="job-ref-font16">
                        <td  colSpan="7"><strong>TOTAL OF ACV</strong></td>
                        <td><strong>&pound;{totalACVJobPrice.toFixed(2)}</strong></td>
                    </tr>
                );
                downloadCsvData = downloadCsvData +
                                            'TOTAL OF ACV'+','+
                                            ''+','+
                                            ''+','+
                                            ''+','+
                                            ''+','+
                                            ''+','+
                                            ''+','+
                                            totalACVJobPrice.toFixed(2)+"\n";
            }
            if(this.state.totaloutsourcedJobs && this.state.totaloutsourcedJobs.bvl && this.state.totaloutsourcedJobs.bvl.length > 0){
                let totalbvlJobPrice = 0.00;
                this.state.totaloutsourcedJobs.bvl.map((job, index) => {
                    let joburl = "/jobs/view/"+job.id;
                    totaloutsourcedJobs.push(
                        <tr key={index+'-'+job.id}>
                            <td className="job-ref-font16"><a href={joburl}>{job.id}</a></td>
                            <td>{ job.vehicle.registration_number}</td> 
                            <td>{ job.customer.name}</td>
                            <td>{ job.subcontracted_to_company.short_name}</td>
                            <td>{ job.status}</td>
                            <td>{((job.driver_completed_at) ? moment(job.driver_completed_at).format("DD/MM/YY") : "")}</td>    
                            <td>{ job.invoice_number}</td>         
                            <td>&pound;{ job.job_price}</td>
                        </tr>
                    );
                    totalbvlJobPrice = parseFloat(totalbvlJobPrice) + parseFloat(job.job_price);
                    downloadCsvData = downloadCsvData +
                                            job.id+','+
                                            job.vehicle.registration_number+','+
                                            job.customer.name+','+
                                            job.subcontracted_to_company.short_name+','+
                                            job.status+','+
                                            ((job.driver_completed_at) ? moment(job.driver_completed_at).format("DD/MM/YY") : "")+','+
                                            job.invoice_number+','+
                                            job.job_price+"\n";
                });
                finalTotal = parseFloat(finalTotal) + parseFloat(totalbvlJobPrice);
                totaloutsourcedJobs.push(
                    <tr key="bvltotal" className="job-ref-font16">
                        <td  colSpan="7"><strong>TOTAL OF BVL</strong></td>
                        <td><strong>&pound;{totalbvlJobPrice.toFixed(2)}</strong></td>
                    </tr>
                );
                downloadCsvData = downloadCsvData +
                                            'TOTAL OF BVL'+','+
                                            ''+','+
                                            ''+','+
                                            ''+','+
                                            ''+','+
                                            ''+','+
                                            ''+','+
                                            totalbvlJobPrice.toFixed(2)+"\n";
            }
            if(this.state.totaloutsourcedJobs && this.state.totaloutsourcedJobs.cnd && this.state.totaloutsourcedJobs.cnd.length > 0){
                let totalcndJobPrice = 0.00;
                this.state.totaloutsourcedJobs.cnd.map((job, index) => {
                    let joburl = "/jobs/view/"+job.id;
                    totaloutsourcedJobs.push(
                        <tr key={index+'-'+job.id}>
                            <td className="job-ref-font16"><a href={joburl}>{job.id}</a></td>
                            <td>{ job.vehicle.registration_number}</td> 
                            <td>{ job.customer.name}</td>
                            <td>{ job.subcontracted_to_company.short_name}</td>
                            <td>{ job.status}</td>
                            <td>{((job.driver_completed_at) ? moment(job.driver_completed_at).format("DD/MM/YY") : "")}</td>    
                            <td>{ job.invoice_number}</td>         
                            <td>&pound;{ job.job_price}</td>
                        </tr>
                    );
                    totalcndJobPrice = parseFloat(totalcndJobPrice) + parseFloat(job.job_price);
                    downloadCsvData = downloadCsvData +
                                            job.id+','+
                                            job.vehicle.registration_number+','+
                                            job.customer.name+','+
                                            job.subcontracted_to_company.short_name+','+
                                            job.status+','+
                                            ((job.driver_completed_at) ? moment(job.driver_completed_at).format("DD/MM/YY") : "")+','+
                                            job.invoice_number+','+
                                            job.job_price+"\n";
                });
                finalTotal = parseFloat(finalTotal) + parseFloat(totalcndJobPrice);
                totaloutsourcedJobs.push(
                    <tr key="cndtotal" className="job-ref-font16">
                        <td  colSpan="7"><strong>TOTAL OF CND</strong></td>
                        <td><strong>&pound;{totalcndJobPrice.toFixed(2)}</strong></td>
                    </tr>
                );
                downloadCsvData = downloadCsvData +
                                            'TOTAL OF CND'+','+
                                            ''+','+
                                            ''+','+
                                            ''+','+
                                            ''+','+
                                            ''+','+
                                            ''+','+
                                            totalcndJobPrice.toFixed(2)+"\n";
            }
            if(this.state.totaloutsourcedJobs && this.state.totaloutsourcedJobs.g4 && this.state.totaloutsourcedJobs.g4.length > 0){
                let totalg4JobPrice = 0.00;
                this.state.totaloutsourcedJobs.g4.map((job, index) => {
                    let joburl = "/jobs/view/"+job.id;
                    totaloutsourcedJobs.push(
                        <tr key={index+'-'+job.id}>
                            <td className="job-ref-font16"><a href={joburl}>{job.id}</a></td>
                            <td>{ job.vehicle.registration_number}</td> 
                            <td>{ job.customer.name}</td>
                            <td>{ job.subcontracted_to_company.short_name}</td>
                            <td>{ job.status}</td>
                            <td>{((job.driver_completed_at) ? moment(job.driver_completed_at).format("DD/MM/YY") : "")}</td>       
                            <td>{ job.invoice_number}</td>      
                            <td>&pound;{ job.job_price}</td>
                        </tr>
                    );
                    totalg4JobPrice = parseFloat(totalg4JobPrice) + parseFloat(job.job_price);
                    downloadCsvData = downloadCsvData +
                                            job.id+','+
                                            job.vehicle.registration_number+','+
                                            job.customer.name+','+
                                            job.subcontracted_to_company.short_name+','+
                                            job.status+','+
                                            ((job.driver_completed_at) ? moment(job.driver_completed_at).format("DD/MM/YY") : "")+','+
                                            job.invoice_number+','+
                                            job.job_price+"\n";
                });
                finalTotal = parseFloat(finalTotal) + parseFloat(totalg4JobPrice);
                totaloutsourcedJobs.push(
                    <tr key="g4total" className="job-ref-font16">
                        <td  colSpan="7"><strong>TOTAL OF G4</strong></td>
                        <td><strong>&pound;{totalg4JobPrice.toFixed(2)}</strong></td>
                    </tr>
                );
                downloadCsvData = downloadCsvData +
                                        'TOTAL OF G4'+','+
                                        ''+','+
                                        ''+','+
                                        ''+','+
                                        ''+','+
                                        ''+','+
                                        ''+','+
                                        totalg4JobPrice.toFixed(2)+"\n";
            }
            if(this.state.totaloutsourcedJobs && this.state.totaloutsourcedJobs.sccd && this.state.totaloutsourcedJobs.sccd.length > 0){
                let totalsccdJobPrice = 0.00;
                this.state.totaloutsourcedJobs.sccd.map((job, index) => {
                    let joburl = "/jobs/view/"+job.id;
                    totaloutsourcedJobs.push(
                        <tr key={index+'-'+job.id}>
                            <td className="job-ref-font16"><a href={joburl}>{job.id}</a></td>
                            <td>{ job.vehicle.registration_number}</td> 
                            <td>{ job.customer.name}</td>
                            <td>{ job.subcontracted_to_company.short_name}</td>
                            <td>{ job.status}</td>
                            <td>{((job.driver_completed_at) ? moment(job.driver_completed_at).format("DD/MM/YY") : "")}</td>        
                            <td>{ job.invoice_number}</td>     
                            <td>&pound;{ job.job_price}</td>
                        </tr>
                    );
                    totalsccdJobPrice = parseFloat(totalsccdJobPrice) + parseFloat(job.job_price);
                    downloadCsvData = downloadCsvData +
                                            job.id+','+
                                            job.vehicle.registration_number+','+
                                            job.customer.name+','+
                                            job.subcontracted_to_company.short_name+','+
                                            job.status+','+
                                            ((job.driver_completed_at) ? moment(job.driver_completed_at).format("DD/MM/YY") : "")+','+
                                            job.invoice_number+','+
                                            job.job_price+"\n";
                });
                finalTotal = parseFloat(finalTotal) + parseFloat(totalsccdJobPrice);
                totaloutsourcedJobs.push(
                    <tr key="sccdtotal" className="job-ref-font16">
                        <td  colSpan="7"><strong>TOTAL OF SCCD</strong></td>
                        <td><strong>&pound;{totalsccdJobPrice.toFixed(2)}</strong></td>
                    </tr>
                );
                downloadCsvData = downloadCsvData +
                                        'TOTAL OF SCCD'+','+
                                        ''+','+
                                        ''+','+
                                        ''+','+
                                        ''+','+
                                        ''+','+
                                        ''+','+
                                        totalsccdJobPrice.toFixed(2)+"\n";
            }
            totaloutsourcedJobs.push(
                <tr key="finaltotal" className="job-ref-font16">
                    <td colSpan="7"><strong>TOTAL OF ALL</strong></td>
                    <td><strong>&pound;{finalTotal.toFixed(2)}</strong></td>
                </tr>
            );
            downloadCsvData = downloadCsvData +
                                        'TOTAL OF ALL'+','+
                                        ''+','+
                                        ''+','+
                                        ''+','+
                                        ''+','+
                                        ''+','+
                                        ''+','+
                                        finalTotal.toFixed(2)+"\n";
            
        
        return (
            <div className="container-fluid">
                <div className="row">
                    <h2> Inter Company Jobs Report</h2>
                    <br/><br/>
                </div>
                <div className="row">
                    <div className="col-md-2">
                        Select From Date:
                    </div>
                    <div className="col-md-2">
                       Select To Date:
                    </div>
                    <div className="col-md-2">
                        Select Customer:
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-2">
                        <DatePicker todayButton={"Today"} dateFormat="dd/MM/yyyy" onChange={this.handleStartDateChange} selected={this.state.startDate}/>
                    </div>
                    <div className="col-md-2">
                        <DatePicker todayButton={"Today"} dateFormat="dd/MM/yyyy" onChange={this.handleEndDateChange} selected={this.state.endDate}/>
                    </div>
                    <div className="col-md-3 col-sm-12">
                        <div>
                            <StatefulMultiSelect
                                options={this.state.customers}
                                selected={selectedCustomers}
                                onSelectedChanged={this.handleCustomerSelection}
                                    overrideStrings={{
                                        selectSomeItems: "Select Customers...",
                                        allItemsAreSelected: "All Customers are Selected",
                                        selectAll: "Select All",
                                        search: "Search Customer",
                                    }}
                                />
                        </div>
                    </div>
                    <div className="col-md-2">
                        <div className="form-group">
                            <button className="btn btn-success btn-lg" disabled={this.state.isLoading ? true:false} onClick={(e) => this.handleTotalJobsRaisedByUserReportGenerate(e)}>
                                <i className="fa fa-download"></i> Generate Outsourced Jobs Report
                            </button>
                        </div>
                    </div>
                    <div className="col-md-2">
                        <div className="form-group">
                            <button className="btn btn-primary btn-lg" disabled={this.state.isDownloading ? true:false} onClick={(e) => {this.downloadableCsvData(this.state.filename,downloadCsvData)}}>
                                <i className="fa fa-download"></i> Download Outsourced Jobs Report {this.state.isDownloading ? <i className="fa fa-spinner fa-pulse"></i> : ''}
                            </button>
                        </div>
                    </div>
                </div>
                {/* <div className="row">
                    <div className="col-md-6">
                        <label className="alert alert-primary"><b>{this.state.totaloutsourcedJobs.length} jobs found..</b></label>
                    </div>             
                </div> */}
                <div className="row">
                    <div className="col-md-10 col-sm-10">
                        <div className="daily-delivered-report-tbl-scroll">
                            <table className="daily-delivered-report-tbl font-normal">
                                <thead className="sticky-top-without-zindex bg-light">
                                   <tr>
                                        <th>Job Ref</th>
                                        <th>REG/VIN</th>
                                        <th>CUSTOMER</th>
                                        <th>Subcontracted To</th>
                                        <th>Status</th>
                                        <th>Driver Completed Date</th>
                                        <th>Invoice Number</th>
                                        <th>Job Price</th>
                                   </tr>
                                </thead> 
                                <tbody>
                                    {this.state.isLoading ? (<tr><td colSpan="8"><span className="add-loading-text"><i className="fa fa-spinner fa-pulse"></i></span></td></tr>) :totaloutsourcedJobs}
                                </tbody>
                            </table>
                        </div>
                        <br/><br/><br/>
                    </div>
                </div>
            </div>
        );
    }
}
if (document.getElementById('react-component-g4-logistics-portal-outsourced-jobs-report')) {
    ReactDOM.render(
        <OutsourcedJobsReport message_if_none = 'Nothing to report on.' />,
        document.getElementById('react-component-g4-logistics-portal-outsourced-jobs-report')
    );
}
